import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';

import flowersImg from '../../styles/theme/mothersDay/Flowers.png';
import styles from './MothersDayFlowers.styl';

const cx = classNames.bind(styles);

const SIDEBAR_SELECTOR = '[data-theme-sidebar]';

function rectsOverlap(a, b) {
  return !(a.right <= b.left || a.left >= b.right || a.bottom <= b.top || a.top >= b.bottom);
}

export default function MothersDayFlowers() {
  const flowersRef = useRef(null);
  const [isHidden, setIsHidden] = useState(false);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const flowers = flowersRef.current;

    if (!flowers) {
      return undefined;
    }

    const observedSidebars = new WeakSet();

    const observeSidebars = () => {
      document.querySelectorAll(SIDEBAR_SELECTOR).forEach(sidebar => {
        if (!observedSidebars.has(sidebar)) {
          resizeObserver.observe(sidebar);
          observedSidebars.add(sidebar);
        }
      });
    };

    const checkOverlap = () => {
      observeSidebars();

      const flowersRect = flowers.getBoundingClientRect();

      if (!flowersRect.width || !flowersRect.height) {
        return;
      }

      const sidebars = document.querySelectorAll(SIDEBAR_SELECTOR);
      let overlaps = false;

      sidebars.forEach(sidebar => {
        const sidebarRect = sidebar.getBoundingClientRect();

        if (sidebarRect.width && sidebarRect.height && rectsOverlap(flowersRect, sidebarRect)) {
          overlaps = true;
        }
      });

      setIsHidden(overlaps);
    };

    const resizeObserver = new ResizeObserver(checkOverlap);

    resizeObserver.observe(flowers);
    observeSidebars();
    checkOverlap();

    window.addEventListener('scroll', checkOverlap, { passive: true });
    window.addEventListener('resize', checkOverlap, { passive: true });

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', checkOverlap);
      window.removeEventListener('resize', checkOverlap);
    };
  }, [pathname]);

  return (
    <img
      ref={flowersRef}
      className={cx('MothersDayFlowers', { MothersDayFlowers_hidden: isHidden })}
      src={flowersImg}
      alt=""
      aria-hidden="true"
    />
  );
}
